import { motion } from 'framer-motion';
import { Chrome } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import AnimatedBackground from '../../components/AnimatedBackground';

// Import logos
import LogoDark from '../../assets/noBgBlack.png';
import LogoLight from '../../assets/noBgWhite.png';

export default function LoginPage() {
  const { login } = useAuth();
  const { theme } = useTheme();
  
  const logoSrc = theme === 'light' ? LogoDark : LogoLight;

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <AnimatedBackground variant="minimal" />
      </div>

      {/* Login Card */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="relative z-10 w-full max-w-md mx-4"
      >
        <div className="bg-card/80 backdrop-blur-xl rounded-2xl border border-border p-8 shadow-2xl">
          {/* Logo */}
          <div className="text-center mb-8">
            <img 
              src={logoSrc} 
              alt="Edalyze Logo" 
              className="h-10 w-auto object-contain mx-auto mb-4"
            />
            <h1 className="text-2xl font-bold mb-2">Welcome to Edalyze</h1>
            <p className="text-muted-foreground">Sign in to access your diagnostic reports</p>
          </div>

          {/* Google Sign In */}
          <Button
            onClick={login}
            data-testid="google-login-btn"
            className="w-full h-12 bg-background hover:bg-muted text-foreground border border-border"
          >
            <Chrome className="w-5 h-5 mr-3" />
            Continue with Google
          </Button>

          {/* Divider */}
          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-border" />
            </div>
            <div className="relative flex justify-center text-xs uppercase">
              <span className="bg-card px-2 text-muted-foreground">Secure login</span>
            </div>
          </div>

          {/* Info */}
          <p className="text-xs text-center text-muted-foreground">
            By continuing, you agree to our{' '}
            <a href="#" className="text-primary hover:underline">Terms of Service</a>
            {' '}and{' '}
            <a href="#" className="text-primary hover:underline">Privacy Policy</a>
          </p>
        </div>

        {/* Back to Home */}
        <div className="text-center mt-6">
          <a 
            href="/" 
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            ← Back to Home
          </a>
        </div>
      </motion.div>
    </div>
  );
}
